module.exports = __webpack_public_path__ + "static/media/benefits-smiley.3693f4ce.jpg";